import { ICON_PATHS, type IconName } from '../constants/icons'

export function isIconName(value: unknown): value is IconName {
  return typeof value === 'string' && Object.hasOwn(ICON_PATHS, value)
}

export function resolveIconName(value: unknown, fallback: IconName): IconName {
  return isIconName(value) ? value : fallback
}
